var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.caja.abierta)?_c('b-button',{staticClass:"m-l-10",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.show_movimientos.apply(null, arguments)}}},[_vm._v(" Mov ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }